import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=fde3201a&scoped=true&"
import script from "./NoAccess.vue?vue&type=script&lang=ts&"
export * from "./NoAccess.vue?vue&type=script&lang=ts&"
import style0 from "./NoAccess.vue?vue&type=style&index=0&id=fde3201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde3201a",
  null
  
)

export default component.exports